export class ElementListeners {
    constructor() {
        this.onSetup = undefined;
        this.onAttach = undefined;
        this.onDetach = undefined;
        this.onActive = undefined;
        this.onInactive = undefined;
        this.onEnabled = undefined;
        this.onDisabled = undefined;
        this.onResize = undefined;
        this.onTextureError = undefined;
        this.onTextureLoaded = undefined;
        this.onTextureUnloaded = undefined;
    }
}
//# sourceMappingURL=ElementListeners.js.map